import classNames from 'classnames';
import React from 'react';
import { useNavigate, useLocation } from 'react-router';
import { modalURLFromLocation } from '@jwp/ott-ui-react/src/utils/location';
import type { PlaylistItem, videoDetails } from '@jwp/ott-common/types/playlist';

import useBreakpoint, { Breakpoint } from '../../hooks/useBreakpoint';
import CollapsibleText from '../CollapsibleText/CollapsibleText';
import Image from '../Image/Image';
import { useUIControls } from '@jwp/ott-hooks-react/src/useUIControls';

import styles from './Hero.module.scss';

type Props = {
  title: string;
  description: string;
  image?: string;
  data: PlaylistItem | videoDetails;
  isHubContent?: boolean;
};

const Hero = ({ title, description, image, data, isHubContent }: Props) => {
  const { heroBanner } = useUIControls();

  const breakpoint: Breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.xs;
  const alt = ''; // intentionally empty for a11y, because adjacent text alternative
  const navigate = useNavigate();
  const location = useLocation();
  const showMoreClickHandler = () => {
    const newState = { item: data, primaryMetadata: null };
    sessionStorage.setItem('seeMoreDetails', JSON.stringify(newState));
    
    navigate(modalURLFromLocation(location, 'show-more-details'), {
      state: newState,
    });
  };

  const getBannerOption = (option: string | undefined) => {
    switch (option) {
      case 'option1':
        return styles.posterOption1;
      case 'option2':
        return styles.posterOption2;
      case 'option3':
        return styles.posterOption3;
      default:
        return styles.posterOption1;
    }
  };


  return (
    <div className={classNames(styles.hero, styles.heroPadding)}>
      <Image className={getBannerOption(heroBanner)} image={image} width={1280} alt={alt} />
      <div className={styles.info}>
        <h1 className={styles.title}>{title}</h1>
        <CollapsibleText
          item={data}
          text={description}
          className={styles.description}
          maxHeight={isMobile ? 60 : 'none'}
          showMoreClickHandler={showMoreClickHandler}
          isHubContent={isHubContent}
        />
      </div>
    </div>
  );
};

export default Hero;
